import { lazy } from "react";
import type { Sale } from "../types";

const SalesList = lazy(() =>
  import("./SalesList").then((m) => ({ default: m.SalesList })),
);
const SalesCreate = lazy(() =>
  import("./SalesCreate").then((m) => ({ default: m.SalesCreate })),
);
const SalesEdit = lazy(() =>
  import("./SalesEdit").then((m) => ({ default: m.SalesEdit })),
);

export default {
  list: SalesList,
  create: SalesCreate,
  edit: SalesEdit,
  // Ikke lazy: se contacts/index.ts.
  recordRepresentation: (record: Sale) =>
    `${record.first_name} ${record.last_name}`,
};
